import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Studio from "@/pages/Studio";
import Host from "@/pages/Host";
import Admin from "@/pages/Admin";
import Viewer from "@/pages/Viewer";
import ViewerPlay from "@/pages/ViewerPlay";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Viewer />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/host" element={<Host />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/viewer" element={<Viewer />} />
          <Route path="/viewer/play/:ticketId" element={<ViewerPlay />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
